import React from "react";
import Body from "../../components/common/body/body";
import BodyTitle from "../../components/common/body-title/body-title";
import BodyText from "../../components/common/body-text/body-text";

let blogTitle = "TCAF!!!";

let blogAuthor = "Posted by Zee / Thursday June 05 2025";

let blogContent = (
  <Body space={0}>
    <BodyTitle>ANNOUNCEMENT:</BodyTitle>
    <BodyText>
      FRANTIC FANFIC CREATOR ZEE WILL BE AT TCAF THIS WEEKEND WITH FRANTIC
      FANFIC STICKERS AND ZINES. She'll be selling the last of the physical
      Frantic Fanfic zines, there's about 15 copies left.
    </BodyText>
    <br />
    <BodyTitle>ENAMEL PIN CAMPAIGN UPDATE:</BodyTitle>
    <BodyText>
      Unfortunately, we had to put the enamel pin campaign on pause because of
      uncertainty with costs due to tariffs imposed by the USA. Even though
      we're located in Canada, sending out the pins could be EXTREMELY EXPENSIVE
      because they would be made in China. We're bummed!! All the work was done
      for the campaign, tiers and all, but hitting that snag sucks. We hope to
      be able to launch it when times are more stable.
    </BodyText>

    <BodyText> See you this weekend at TCAF!</BodyText>
    <br />
    <BodyText>Zee and Michael.</BodyText>
  </Body>
);

export let blog = {
  title: blogTitle,
  author: blogAuthor,
  content: blogContent,
};
